<template>
<div :class="preClass">
  <div v-if="smallScale">
    <base-table :data="monthData" :headers="smallScaleHeaders"></base-table>
    <div :class="preClass+'-tips'">
      <p>距一般人收入上限：{{amountGap}}万元</p>
      <p v-show="amountGap>0">提示：贵公司从{{monthArray[0]}}至本月累计收入{{allValue}}万元，距转一般纳税人标准（500万）相差{{amountGap}}万元，请根据企业自身情况酌情开展本月业务</p>
      <p v-show="amountGap<=0">提示：贵公司从{{monthArray[0]}}至本月累计收入{{allValue}}万元，您已达到纳税人标准(500万)，请根据企业自身情况酌情开展本月业务</p>
    </div>
    <div id="incomEchart" style="width:100%;height:300px;margin-top:20px"></div>
  </div>
  <div v-else>
    <div class="title-wrap">
      <p>{{ year }}年度累计发生明细</p>
      <p>{{ begin_time }}- {{ end_time }}</p>
    </div>
    <base-table :data="subjectData" :headers="headers"></base-table>
  </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import {mathMoney} from '@/utils'

export default {
  data() {
    return {
      preClass: "financial-report-detail-incom",
      headers: ["科目名称", "本年累计金额（元）"],
      smallScaleHeaders: ["月份", "收入金额（万元）", "累计收入金额（万元）"],
      monthArray: [],
      monthData: [],
      allValue:0
    };
  },
  props: {
    data:[Object],
    year: [String, Number],
    begin_time: [String, Number],
    end_time: [String, Number],
    dateType: [String, Number],
    subjectData: Array
  },
  computed: {
    ...mapGetters(["smallScale"]),
    mathMoney(){
      return mathMoney
    },
    amountGap(){
      return 500-this.allValue
    }
  },
  mounted() {
    this.init();

  },
  watch:{
   dateType(){
    this.init();
   } 
  },
  methods: {
    init() {
      if (this.smallScale) {
        this.getMonth();
        this.initEcharts();
      }
    },
    getMonth() {
      var dataArr = [];
      var data = "";
      if (this.dateType === 0) {
        data = new Date();
        data.setMonth(data.getMonth() +1, 1); //获取到当前月份,设置月份
      } else {
        data = new Date(this.end_time);
        data.setMonth(data.getMonth() +2, 1); //获取到当前月份,设置月份

      }
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
        var m = data.getMonth();
        m = m < 10 ? "0" + m : m;
        dataArr.unshift(data.getFullYear() + "-" + m + "-01");
        this.monthArray = dataArr;
      }
    },
    initEcharts() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      let params = {
        begin_ym: this.monthArray[0],
        end_ym: this.monthArray[this.monthArray.length - 1],
        ak_id: 171
      };
      this.$axios.post("/account-book/subsidiary-ledger", params).then(res => {
        console.log("res", res);
        let xAxis = [];
        // 月收入情况
        let yData1 = [];
        // 前十一个月累计
        let yData2 = [];
        let all = 0
        this.monthData = res.rows.map(item => {
          item.curr_date = item.curr_date.substr(0, 10);
          item.curr_credit= mathMoney(item.curr_credit)
          all = all+Number(item.curr_credit)
          xAxis.push(item.curr_date);
          yData1.push(item.curr_credit);
          yData2.push(all );
          return {
            ...item,
            title: item.curr_date,
            value: item.curr_credit,
            value2: all,
            align: "around",
            filter: "toThousandFilter"
          };
        });
        this.allValue = this.monthData[this.monthData.length-1].value2
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById("incomEchart"));
        // 绘制图表
        myChart.setOption({
          title: {
            text: "前十一个月累计收入情况（万元）",
            subtext: "数据来源：chunxue.cn"
            // textAlign :'center',
          },
          tooltip: {
            trigger: "axis"
          },
          legend: {
            top: 50,
            bottom: 20,
            left: 0,
            data: ["月收入情况", "前十一个月累计收入情况", "一般人收入标准"]
          },
          grid: {
            top: 110,
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: xAxis
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "月收入情况",
              type: "line",
              data: yData1
            },
            {
              name: "前十一个月累计收入情况",
              type: "line",
              data: yData2
            },
            {
              name: "一般人收入标准",
              type: "line",
              data: [500, 500, 500, 500, 500, 500, 500]
            }
          ]
        });
      }).finally(_=>{
      this.$store.commit('app/SET_LOADING_STATUS', false)

      });
    }
  }
};
</script>

<style lang='less'>
.financial-report-detail-incom{
  &-tips{
    font-size: 16px;
    p:nth-child(1){
      background: #5ceaea;
      color: #fff;
       line-height: 1rem;
       padding: 10px;
    }
     p:nth-child(2){
       line-height: 1.2rem;
       padding: 10px;
      background: #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/basic-info/components/income.vue